export const setToModel = function () {
  let [ model, ...dataList ] = arguments
  dataList = dataList || []
  dataList = dataList.reverse()
  return Object.keys(model)
    .reduce((result, key) => {
      let data = dataList.find((dataItem) => {
        return dataItem && dataItem[key] !== undefined
      }) || model
      result[key] = data[key]
      return result
    }, {})
}
export const keepToModel = (model, arg) => {
  const argsRevers = [arg].filter(Boolean).reverse()
  const keys = Object.keys(model)
  return keys.reduce((acc, key) => {
    const targetValue = argsRevers.find((item) => item.hasOwnProperty(key))
    if (targetValue) {
      acc[key] = targetValue[key]
    }
    return acc
  }, {})
}

export const readProps = (strTemplate = '', object = {}, errorValue = '') => {
  strTemplate = String(strTemplate)
  let result = object
  let keys = strTemplate.split('.')
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i]
    if (result[key]) {
      result = result[key]
    } else {
      result = errorValue
      break
    }
  }
  return result
}
export const removeFromString = (str, sub) => {
  return String(str || '').replace(new RegExp(`${sub}`, 'g'), '')
}
export const kebabize = str => {
  return str.split('').map((letter, idx) => {
    return letter.toUpperCase() === letter
      ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
      : letter
  }).join('')
}
export const toKebab = (field) => {
  return String(field)
    .replace(/[A-Z]/g, (substring) => {
      return `-${substring}`
    })
    .toLowerCase()
    .replace(/^-/gi, '')
}
